<template>
  <div class="the-footer">
    中国中医科学院中医药信息研究所版权所有  电话：（+86 10）64089611 64089628
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.the-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #c79a67;
  color: #fff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue